import { ReferenceDataCatalogue } from '@aw/prypco/services/reference-data';

export class Text {
  constructor(
    readonly value: string,
    readonly catalogue?: ReferenceDataCatalogue,
  ) {}
}
